import React from 'react';
import MCPServerTable from './MCPServerTable';

const TableView = ({ servers }) => {
  return (
    <div className="table-view">
      <MCPServerTable servers={servers} />
    </div>
  );
};

export default TableView;
